import View from '../core/View';
import DropdownMenuView from './DropdownMenuView';

export default class LibraryCatalogToolbarView extends View {

    createView(model) {

        let libraryCatalog = model['libraryCatalog'];
        let visualTemplate = model['visualTemplate'];

        let toolbarDOM = $('<div>', {
            class: 'toolbar',
            css: {
                'margin': '0px',
                'padding': '8px',
                'width': '100%',
                'height': '40px',
                //'position': 'absolute',
                //'left': '0',
                //'top': '0',
                'background-color': visualTemplate.toolbarBackgroundColor
            }
        });

        // Back button
        if (!libraryCatalog.useAsRoot && libraryCatalog.showExitButton) {
            let btnName = this.app.polyglot.t("Back");
            $('<button>', {
                class: 'btn btn-xs btn-default',
                css: {
                    'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                    'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                    'border': '0px',
                    'font-size': '16px',
                    'font-weight': 'bold',
                    'float': 'left'
                },
                text: btnName,
                click: this.onBackButtonPressed.bind(this)
            }).appendTo(toolbarDOM);
        }

        // Menu dropdown
        if (libraryCatalog.catalogType != "PDF") {
            let menuJson = {};

            if (this.app.cds) {
                let textLogin = this.app.polyglot.t("Login");
                let textLogout = this.app.polyglot.t("Logout");

                if (this.app.cdsConfig.cdsUsername.length == 0)
                    menuJson[textLogin] = function() { this.login(); }.bind(this);
                else
                    menuJson[textLogout] = function() { this.logout(); }.bind(this);
            }

            if (visualTemplate.showSearchButton) {
                let btnName = this.app.polyglot.t("Search");
                menuJson[btnName] = function() {
                    $('#searchModal').on('shown.bs.modal', function () {
                        $('#searchInput').focus();
                    }).modal('show');
                }.bind(this);
            }

            if (visualTemplate.showChangeLanguageButton) {
                let btnName = this.app.polyglot.t("Languages");
                menuJson[btnName] = {
                    'Español': function() { this.changeLanguage('es');}.bind(this),
                    'English': function() { this.changeLanguage('en'); }.bind(this),
                    'Chino': function() { this.changeLanguage('zh'); }.bind(this)
                };
            }

            if (this.app.library.appUrl && this.app.library.appUrl.length > 0) {
                let btnName = this.app.polyglot.t("Web");
                menuJson[btnName] = function() {
                    window.open(this.app.library.appUrl, '_blank');
                }.bind(this);
            }

            if (!$.isEmptyObject(menuJson)) {
                this.app.createView(new DropdownMenuView(), {
                    'menuJson': menuJson,
                    'visualTemplate': visualTemplate
                }).appendTo(toolbarDOM);
            }

            if (this.app.cds && this.app.cdsConfig.cdsUsername.length > 0) {
                $('<div>', {
                    text: this.app.cdsConfig.cdsUsername,
                    css: {
                        'float': 'right',
                        'color': visualTemplate.toolbarTintSecondaryColor,
                        'font-weight': 'bold'
                    }
                }).appendTo(toolbarDOM);
            }
        } else { // Es PDF
            // Share button
            $('<div>', {
                id: 'shareButtons',
                class: '',
                css: {
                    'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                    'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                    'border': '0px',
                    'font-size': '16px',
                    'font-weight': 'bold',
                    'float': 'right',
                    'margin-top': '-8px',
                    'margin-left': '8px'
                },
                text: this.app.polyglot.t("Share"),
            })
                .appendTo(toolbarDOM)
                .jsSocials({
                    showCount: false,
                    showLabel: false,
                    shares: [
                        "email",
                        "twitter",
                        "facebook",
                    ],
                    on: {
                        click: this.onShareButtonPressed.bind(this)
                    }
                });

            // Download button
            $('<button>', {
                class: 'btn btn-xs btn-default',
                css: {
                    'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                    'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                    'border': '0px',
                    'font-size': '16px',
                    'font-weight': 'bold',
                    'float': 'right'
                },
                html: '<i class="fa fa-download"></i> ' + this.app.polyglot.t("Download"),
                click: this.onDownloadButtonPressed.bind(this, model['url'], libraryCatalog.title + '.pdf')
            }).appendTo(toolbarDOM);
        }

        // Toolbar title
        $('<h1>', {
            text: libraryCatalog.title,
            css: {
                'margin': '0px',
                'text-align': 'center',
                'font-size': '1.5em',
                'color': visualTemplate.toolbarTintColor
            }
        }).appendTo(toolbarDOM);

        $('<div>', {
            css: {
                'clear': 'both'
            }
        }).appendTo(toolbarDOM);

        return toolbarDOM;

    }

    onBackButtonPressed() {
        this.app.goBack();
    }

    changeLanguage(lang) {
        this.app.changeCurrentLanguage(lang);
    }

    login() {
        let textUsername = this.app.polyglot.t("Username");
        let textPassword = this.app.polyglot.t("Password");
        let textRemember = this.app.polyglot.t("Remember");
        let textLogin = this.app.polyglot.t("Login");

        $('#loginDialog').remove();

        let d = $('<div>', {
            id: 'loginDialog',
            title: textLogin,
            html: '<label for="login_username">'+textUsername+':</label><br/><input type="text" id="login_username"/><br/>' +
            '<label for="login_password">'+textPassword+':</label><br/><input type="password" id="login_password"/><br/>' +
            '<input type="checkbox" id="login_remember"><label for="login_remember" style="margin-left:5px;">'+textRemember+'</label>',
            keypress: function(e) {
                if (e.keyCode == $.ui.keyCode.ENTER) {
                    $('#loginButton').trigger("click");
                }
            }
        }).dialog({
            modal: true,
            buttons: [
                {
                    id: 'loginButton',
                    text: textLogin,
                    click: () => {
                        let username = d.children('#login_username').val();
                        let password = d.children('#login_password').val();
                        let remember = d.children('#login_remember').is(':checked');

                        if (username.length > 0 || password.length > 0) {
                            $('#loginDialog').dialog("close");
                            this.app.login(username, password, remember);
                        }
                    }
                }
            ]
        });
    }

    logout() {
        this.app.logout();
    }

    onDownloadButtonPressed(fileURL, fileName) {
        let url = window.location.href.replace('index.html', '');
        ga('send', 'event', 'Descargar', 'click',  'En la url ' + url);
        this.save2Disk(fileURL, fileName);
    }

    save2Disk(fileURL, fileName) {
        // for non-IE
        if (!window.ActiveXObject) {
            let save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            let evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }

        // for IE < 11
        else if ( !! window.ActiveXObject && document.execCommand)     {
            let _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
    }

    onShareButtonPressed() {
        let url = window.location.href.replace('index.html', '');
        ga('send', 'event', 'Compartir', 'click', 'En la url ' + url);
    }

}
